import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CssVarsProvider, extendTheme } from "@mui/joy/styles";
import {
    Box,
    Button,
    CssBaseline,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Typography,
} from "@mui/joy";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { getVendorId } from "../utils/VendorIdUtil";

const AdminLoginPage = ({ onAdminLogin }) => {
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const API_BASE = process.env.REACT_APP_ADMIN_API_BASE || 'http://localhost:9300';

    const handleGoogleSuccess = async (response) => {
        const token = response.credential;
        const vendorID = await getVendorId();

        const requestData = {
            token: token,
            vendor_id: vendorID,
            platform: "web",
            app_version_code: 1,
            push_token: ""
        };

        fetch(`${API_BASE}/auth/google`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestData)
        })
            .then(response => {
                console.log(response);
                if (!response.ok) {
                    throw new Error("Google login failed on the server");
                }
                return response.json();
            })
            .then(data => {
                // Let admin context store session
                onAdminLogin(data, vendorID);
                navigate('/admin');
            })
            .catch(error => {
                setError("Google login failed");
            });
    };

    const handleGoogleError = () => {
        setError("Google Sign-In failed");
    };

    const customTheme = extendTheme({ defaultColorScheme: 'dark' });

    return (
        <GoogleOAuthProvider clientId="407304921843-lgma5ltkdqet9pakp2chb70g2pae0uuf.apps.googleusercontent.com">
            <CssVarsProvider theme={customTheme} disableTransitionOnChange>
                <CssBaseline />
                <Box
                    sx={(theme) => ({
                        width: '100%',
                        position: 'center',
                        zIndex: 1,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        backdropFilter: 'blur(12px)',
                        backgroundColor: 'rgba(255 255 255 / 0.2)',
                        [theme.getColorSchemeSelector('dark')]: {
                            backgroundColor: 'rgba(19 19 24 / 0.4)',
                        },
                    })}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100dvh',
                            width: '100%',
                            px: 2,
                        }}
                    >
                        <Box component="header" sx={{ py: 3 }}>
                            <Typography level="title-lg">AiHub Admin</Typography>
                        </Box>

                        <Box
                            component="main"
                            sx={{
                                my: 'auto',
                                py: 2,
                                pb: 5,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                width: 400,
                                maxWidth: '100%',
                                mx: 'auto',
                                borderRadius: 'sm',
                            }}
                        >
                            <Stack sx={{ gap: 4, mb: 2 }}>
                                <Typography component="h1" level="h3">
                                    Admin Sign in
                                </Typography>
                            </Stack>

                            {error && <Typography color="red">{error}</Typography>}

                            <Stack sx={{ gap: 4, mt: 2 }}>
                                <GoogleLogin
                                    onSuccess={handleGoogleSuccess}
                                    onError={handleGoogleError}
                                />
                            </Stack>
                        </Box>
                    </Box>
                </Box>
            </CssVarsProvider>
        </GoogleOAuthProvider>
    );
};

export default AdminLoginPage; 